var exports = {
  "B": "messageContent__Z__RgH",
};

module.exports = exports;
